import React from "react"
import {Bell, List, File, Home, Lock, Star, User, Users, UserCheck} from "react-feather"

import {trans} from '@utils'

export const Navigation = [
  {
    id: 'adminList',
    title: 'user.nav.adminList',
    icon: <Lock />,
    navLink: '/admin/list',
    action: 'call',
    resource: 'NoPermissionCode'
  }
]
